import { MobileBaseField } from '../BaseField/models';

// Used for MobileEmailField
export const EmailAddress = Backbone.Model.extend({
    defaults: {
        email: null,
        possible_emails: null // array of all emails for a given contact
    },

    initialize: function (attributes, options) {
        if (!this.get('possible_emails')) {
            this.set('possible_emails', []);
        }

        this._isValid = true; // innocent until proven guilty
    },

    validation: {
        email: {
            pattern: 'email',
            required: false // we'll handle "required" in the email field model
        }
    }
});

// Used for MobileEmailField
export const EmailAddresses = Backbone.Collection.extend({
    model: EmailAddress,

    /**
     * Checks each model if they're valid.
     * @return {Boolean} True if all models are valid, false if any aren't.
     */
    is_valid: function () {
        var _is_valid = true;
        this.each(function (model, i) {
            if (!model.isValid(true)) {
                _is_valid = false;
            }
        });
        return _is_valid;
    }
});

export const MobileEmailField = MobileBaseField.extend({
    emails_collection: null, // EmailAddresses - email values in model form

    validation: {
        value: {
            fn: function (val, attr, computed) {
                if (!val && this._is_required(val, attr, computed)) {
                    return 'Email field is required';
                }
                if (!this.emails_collection || this.emails_collection.length == 0) {
                    return;
                }
                if (!this.emails_collection.is_valid()) {
                    return 'Invalid email address';
                }
            }
        }
    }
});
